<div class="space-y-6">
  <app-page-header
    title="Rôles"
    subtitle="Rôles Keycloak du realm Nawam — appliqués aux utilisateurs via les assignations."
  >
    <a
      slot="actions"
      routerLink="/roles/new"
      class="inline-flex items-center justify-center gap-2 rounded-lg bg-brand-500 px-5 py-2.5 text-sm font-medium text-white shadow-theme-xs transition hover:bg-brand-600"
    >
      <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 4.167v11.666M4.167 10h11.666" stroke="currentColor" stroke-width="1.667" stroke-linecap="round" />
      </svg>
      Nouveau rôle
    </a>
  </app-page-header>

  <section class="rounded-2xl border border-gray-200 bg-white shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
    <div class="border-b border-gray-200 px-5 py-4 dark:border-gray-800">
      <div class="relative max-w-md">
        <span class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3.5 text-gray-400">
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.04199 9.37381C3.04199 5.87712 5.87711 3.04199 9.3738 3.04199C12.8705 3.04199 15.7056 5.87712 15.7056 9.37381C15.7056 10.9354 15.1399 12.3646 14.2024 13.4685L16.5979 15.8638C16.8908 16.1567 16.8908 16.6315 16.5979 16.9244C16.305 17.2173 15.8302 17.2173 15.5373 16.9244L13.1422 14.529C12.0381 15.4674 10.6083 16.0337 9.3738 16.0337C5.87711 16.0337 3.04199 13.1985 3.04199 9.37381ZM9.3738 4.54199C6.70557 4.54199 4.54199 6.70557 4.54199 9.37381C4.54199 12.0421 6.70557 14.2056 9.3738 14.2056C12.042 14.2056 14.2056 12.0421 14.2056 9.37381C14.2056 6.70557 12.042 4.54199 9.3738 4.54199Z" fill="currentColor" />
          </svg>
        </span>
        <input
          type="text"
          placeholder="Rechercher un rôle…"
          [formControl]="searchCtrl"
          class="h-11 w-full rounded-lg border border-gray-300 bg-transparent pl-11 pr-4 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/20 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
        />
      </div>
    </div>

    @if (error() || loading() || filteredRoles().length === 0) {
      <app-data-state
        [loading]="loading()"
        [error]="error()"
        [empty]="!loading() && !error() && filteredRoles().length === 0"
        loadingMessage="Chargement des rôles…"
        emptyMessage="Aucun rôle trouvé."
        (retry)="load()"
      />
    } @else {
      <div class="overflow-x-auto">
        <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-800">
          <thead class="bg-gray-50 dark:bg-white/[0.02]">
            <tr>
              <th class="px-5 py-3 text-left text-theme-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Nom</th>
              <th class="px-5 py-3 text-left text-theme-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Description</th>
              <th class="px-5 py-3 text-left text-theme-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Type</th>
              <th class="px-5 py-3 text-right text-theme-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Actions</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200 bg-white dark:divide-gray-800 dark:bg-transparent">
            @for (r of filteredRoles(); track r.name) {
              <tr class="transition hover:bg-gray-50 dark:hover:bg-white/[0.02]">
                <td class="whitespace-nowrap px-5 py-4">
                  <div class="flex items-center gap-2">
                    <span class="font-mono text-sm font-medium text-gray-800 dark:text-white/90">{{ r.name }}</span>
                    <span
                      class="inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-medium"
                      [class.bg-brand-50]="isBusinessRole(r.name)"
                      [class.text-brand-700]="isBusinessRole(r.name)"
                      [class.dark:bg-brand-500/15]="isBusinessRole(r.name)"
                      [class.dark:text-brand-400]="isBusinessRole(r.name)"
                      [class.bg-gray-100]="!isBusinessRole(r.name)"
                      [class.text-gray-600]="!isBusinessRole(r.name)"
                      [class.dark:bg-gray-800]="!isBusinessRole(r.name)"
                      [class.dark:text-gray-400]="!isBusinessRole(r.name)"
                    >
                      {{ isBusinessRole(r.name) ? 'métier' : 'système' }}
                    </span>
                  </div>
                </td>
                <td class="px-5 py-4">
                  <p class="text-sm text-gray-700 dark:text-gray-300">{{ r.description || '—' }}</p>
                </td>
                <td class="whitespace-nowrap px-5 py-4">
                  @if (r.composite) {
                    <span class="inline-flex items-center gap-1 rounded-full bg-warning-50 px-2 py-0.5 text-[10px] font-medium text-warning-700 dark:bg-warning-500/15 dark:text-warning-400">Composite</span>
                  } @else if (r.clientRole) {
                    <span class="inline-flex items-center gap-1 rounded-full bg-blue-light-50 px-2 py-0.5 text-[10px] font-medium text-blue-light-700 dark:bg-blue-light-500/15 dark:text-blue-light-400">Client</span>
                  } @else {
                    <span class="inline-flex items-center gap-1 rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-medium text-gray-600 dark:bg-gray-800 dark:text-gray-400">Realm</span>
                  }
                </td>
                <td class="whitespace-nowrap px-5 py-4 text-right">
                  <a [routerLink]="['/roles', r.name]" class="text-xs font-medium text-brand-600 hover:text-brand-700 dark:text-brand-400">Voir</a>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="border-t border-gray-200 px-5 py-3 text-xs text-gray-500 dark:border-gray-800 dark:text-gray-400">
        {{ filteredRoles().length }} rôle(s)
      </div>
    }
  </section>
</div>
